import { render, staticRenderFns } from "./SessionsFilter.vue?vue&type=template&id=85a374e4"
import script from "./SessionsFilter.vue?vue&type=script&lang=js"
export * from "./SessionsFilter.vue?vue&type=script&lang=js"
import style0 from "./SessionsFilter.vue?vue&type=style&index=0&id=85a374e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports